import React from "react";
import { SpriteIcon } from "@shared/ui/SpriteIcon";
import classes from "./payments.module.scss";

export const Payments = () => {
    return (
        <div className={classes.payments}>
            <SpriteIcon
                className={classes["payments__item"]}
                section={"payment-systems"}
                name={"mir"}
            />
            <SpriteIcon
                className={classes["payments__item"]}
                section={"payment-systems"}
                name={"visa"}
            />
            <SpriteIcon
                className={classes["payments__item"]}
                section={"payment-systems"}
                name={"visa-electron"}
            />
            <SpriteIcon
                className={classes["payments__item"]}
                section={"payment-systems"}
                name={"mastercard"}
            />
            <SpriteIcon
                className={classes["payments__item"]}
                section={"payment-systems"}
                name={"sbp"}
            />
        </div>
    );
};